const Button = ({
    text,
    onClick,
    loading,
    disabled = false,
    type = "button",
    className = "",
    isHideIcon = false
}) => {
    return (
        <button
            type={type}
            className={`w-100 rounded-pill py-2 ${className}`}
            onClick={onClick}
            disabled={loading || disabled}
        >
            {loading ? "Please wait..." : text}

        {!isHideIcon && <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                className="ms-2"
            >
                <path
                    fill="#fff"
                    d="M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5zm9 12h-8v2h10V3H12v2h8z"
                />
            </svg> }
            
        </button>
    );
};

export default Button;